export default "__VITE_ASSET__CWdHj4hz__"